var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardCreateImageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 212,
    viewBox: "0 0 311 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_1367_97434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.291 11H69.9225C64.3114 11 59.7627 15.5467 59.7627 21.1554V161.919C59.7627 167.528 64.3114 172.075 69.9225 172.075H267.291C272.902 172.075 277.451 167.528 277.451 161.919V21.1554C277.451 15.5467 272.902 11 267.291 11Z",
    fill: "#877D7D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.661 19.4775H76.5547C71.445 19.4775 67.3027 23.618 67.3027 28.7255V154.349C67.3027 159.457 71.445 163.597 76.5547 163.597H260.661C265.771 163.597 269.913 159.457 269.913 154.349V28.7255C269.913 23.618 265.771 19.4775 260.661 19.4775Z",
    fill: "url(#paint0_linear_1367_97434)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.655 86.8756C135.86 86.8756 114.899 107.563 114.472 133.246C114.464 133.685 114.108 134.045 113.669 134.045H94.952C94.5121 134.045 94.1552 133.685 94.1602 133.245C94.5889 96.3512 124.643 66.5752 161.655 66.5752C198.667 66.5752 228.72 96.3512 229.15 133.245C229.154 133.685 228.797 134.045 228.358 134.045H209.641C209.201 134.045 208.845 133.685 208.838 133.246C208.411 107.563 187.45 86.8756 161.655 86.8756Z",
    fill: "#6B88AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.844 134.045C208.844 115.475 198.109 99.3916 182.458 91.6925L191.426 73.478C213.754 84.4612 229.154 107.446 229.154 134.045H208.844Z",
    fill: "#E8E5FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.53 27.9551H97.222C96.0509 27.9551 95.1016 28.904 95.1016 30.0745C95.1016 31.245 96.0509 32.1938 97.222 32.1938H108.53C109.701 32.1938 110.651 31.245 110.651 30.0745C110.651 28.904 109.701 27.9551 108.53 27.9551Z",
    fill: "#55BBE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.48 27.9551H201.826C200.655 27.9551 199.706 28.904 199.706 30.0745C199.706 31.245 200.655 32.1938 201.826 32.1938H207.48C208.652 32.1938 209.601 31.245 209.601 30.0745C209.601 28.904 208.652 27.9551 207.48 27.9551Z",
    fill: "#55BBE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.852 140.251L150.031 140.066C148.859 140.056 147.902 140.997 147.893 142.168C147.883 143.338 148.825 144.295 149.996 144.304L172.817 144.49C173.988 144.499 174.945 143.558 174.955 142.388C174.964 141.217 174.023 140.261 172.852 140.251Z",
    fill: "#55BBE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.131 147.588C154.131 147.07 154.551 146.649 155.069 146.649H167.779C168.297 146.649 168.717 147.07 168.717 147.588C168.717 148.106 168.297 148.526 167.779 148.526H161.424H155.069C154.551 148.526 154.131 148.106 154.131 147.588Z",
    fill: "#D9D9FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.368 35.9619H96.2795C95.6289 35.9619 95.1016 36.4891 95.1016 37.1393C95.1016 37.7896 95.6289 38.3167 96.2795 38.3167H119.368C120.018 38.3167 120.546 37.7896 120.546 37.1393C120.546 36.4891 120.018 35.9619 119.368 35.9619Z",
    fill: "#DDDCFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.491 35.9619H200.884C200.233 35.9619 199.706 36.4891 199.706 37.1393C199.706 37.7896 200.233 38.3167 200.884 38.3167H215.491C216.141 38.3167 216.669 37.7896 216.669 37.1393C216.669 36.4891 216.141 35.9619 215.491 35.9619Z",
    fill: "#DDDCFE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_1367_97434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.304 106.137H233.904C228.548 106.137 224.207 110.477 224.207 115.829V179.565C224.207 184.918 228.548 189.257 233.904 189.257H283.304C288.659 189.257 293 184.918 293 179.565V115.829C293 110.477 288.659 106.137 283.304 106.137Z",
    fill: "#343030"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.929 136.75V172.075",
    stroke: "#E194CE",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.749 136.75V172.075",
    stroke: "#55BBE9",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M251.536 156.532V172.075",
    stroke: "#55BBE9",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M266.144 162.184V172.075",
    stroke: "#E194CE",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M244.619 118.983H272.589",
    stroke: "#E8E5FC",
    strokeWidth: 13.783,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii_1367_97434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4234 34.5488H22.8257C18.5037 34.5488 15 38.051 15 42.3711V98.3153C15 102.635 18.5037 106.138 22.8257 106.138H70.4234C74.7454 106.138 78.2491 102.635 78.2491 98.3153V42.3711C78.2491 38.051 74.7454 34.5488 70.4234 34.5488Z",
    fill: "#343030"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4169 74.33C38.9832 74.33 38.5977 74.2681 38.2603 74.1442C37.9297 74.0203 37.6473 73.824 37.4132 73.5556C37.1791 73.2872 37.0036 72.9328 36.8865 72.4923C36.7695 72.0449 36.7109 71.5013 36.7109 70.8611C36.7109 70.1386 36.7695 69.5294 36.8865 69.0337C37.0036 68.5384 37.1723 68.1425 37.3926 67.8465C37.6199 67.5439 37.8987 67.327 38.2291 67.1963C38.5598 67.0654 38.9419 67 39.3757 67C39.8989 67 40.3329 67.0965 40.6771 67.289C41.0281 67.4818 41.2864 67.7467 41.4518 68.084C41.6238 68.4145 41.71 68.7998 41.71 69.2403H40.3156C40.3156 68.9993 40.2811 68.7965 40.2122 68.6311C40.1433 68.4592 40.0367 68.3283 39.8921 68.2388C39.7475 68.1493 39.565 68.1046 39.3447 68.1046C39.0211 68.1046 38.7732 68.1908 38.601 68.3627C38.4358 68.5281 38.3222 68.7724 38.2603 69.0958C38.2052 69.4193 38.1741 69.8116 38.1673 70.2728C38.2362 70.2039 38.3395 70.1212 38.477 70.025C38.6216 69.9285 38.8007 69.846 39.0141 69.7772C39.2276 69.7015 39.4584 69.6636 39.7063 69.6636C40.1951 69.6636 40.6047 69.7633 40.9353 69.9629C41.2728 70.1557 41.524 70.4241 41.6892 70.7682C41.8546 71.1125 41.9371 71.5116 41.9371 71.9657C41.9371 72.4545 41.827 72.8778 41.6067 73.2357C41.3932 73.5866 41.097 73.8585 40.7184 74.0512C40.3465 74.237 39.9128 74.33 39.4169 74.33ZM39.3654 73.2151C39.6201 73.2151 39.83 73.1633 39.9955 73.06C40.1607 72.9499 40.2846 72.8021 40.3671 72.6162C40.4498 72.4234 40.4911 72.21 40.4911 71.976C40.4911 71.7285 40.4498 71.5116 40.3671 71.3256C40.2846 71.1399 40.1607 70.9953 39.9955 70.8921C39.83 70.782 39.6201 70.7269 39.3654 70.7269C39.1175 70.7269 38.9075 70.782 38.7353 70.8921C38.5701 70.9953 38.4461 71.1399 38.3634 71.3256C38.2809 71.5116 38.2397 71.7285 38.2397 71.976C38.2397 72.217 38.2809 72.4337 38.3634 72.6265C38.4461 72.8124 38.5701 72.9569 38.7353 73.06C38.9075 73.1633 39.1175 73.2151 39.3654 73.2151Z",
    fill: "#E8E5FC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6406 74.33C45.2137 74.33 44.8385 74.2681 44.5149 74.1442C44.1911 74.0133 43.9193 73.8069 43.6988 73.5247C43.4855 73.2357 43.3236 72.8572 43.2135 72.389C43.1102 71.921 43.0586 71.3464 43.0586 70.6651C43.0586 69.9767 43.1102 69.402 43.2135 68.941C43.3236 68.4728 43.4855 68.0943 43.6988 67.8053C43.9193 67.5162 44.1911 67.3097 44.5149 67.186C44.8385 67.0621 45.2137 67 45.6406 67C46.0744 67 46.4497 67.0621 46.7663 67.186C47.0831 67.3097 47.3482 67.5162 47.5616 67.8053C47.7821 68.0943 47.9438 68.4728 48.0471 68.941C48.1573 69.402 48.2123 69.9767 48.2123 70.6651C48.2123 71.3464 48.1573 71.921 48.0471 72.389C47.9438 72.8572 47.7821 73.2357 47.5616 73.5247C47.3482 73.8069 47.0831 74.0133 46.7663 74.1442C46.4497 74.2681 46.0744 74.33 45.6406 74.33ZM45.6406 73.2151C45.9436 73.2151 46.1742 73.1359 46.3326 72.9776C46.491 72.8124 46.6011 72.5646 46.6632 72.2342C46.7251 71.9039 46.756 71.491 46.756 70.9954V70.3552C46.756 69.8528 46.7251 69.4364 46.6632 69.1061C46.6011 68.7688 46.491 68.5175 46.3326 68.3524C46.1742 68.1873 45.9436 68.1046 45.6406 68.1046C45.3376 68.1046 45.1036 68.1873 44.9384 68.3524C44.7799 68.5175 44.6698 68.7653 44.6077 69.0958C44.5459 69.4193 44.5149 69.8322 44.5149 70.3346V70.9747C44.5149 71.4771 44.5459 71.8969 44.6077 72.2342C44.6698 72.5646 44.7799 72.8124 44.9384 72.9776C45.1036 73.1359 45.3376 73.2151 45.6406 73.2151Z",
    fill: "#E8E5FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9471 74.2061L55.946 67.1239H56.9686L51.9592 74.2061H50.9471ZM51.4739 70.7166C51.1088 70.7166 50.7955 70.6546 50.534 70.5309C50.2791 70.407 50.0829 70.2107 49.9452 69.9423C49.8144 69.6739 49.749 69.3125 49.749 68.8583C49.749 68.4042 49.8144 68.0428 49.9452 67.7743C50.0829 67.4991 50.2791 67.3029 50.534 67.186C50.7955 67.0621 51.1088 67 51.4739 67C51.8458 67 52.1591 67.0621 52.4138 67.186C52.6685 67.3029 52.8613 67.4991 52.9921 67.7743C53.1299 68.0428 53.1988 68.4042 53.1988 68.8583C53.1988 69.3125 53.1299 69.6774 52.9921 69.9526C52.8613 70.221 52.6685 70.4173 52.4138 70.5412C52.1591 70.6581 51.8458 70.7166 51.4739 70.7166ZM51.4739 69.9423C51.7492 69.9423 51.9318 69.8528 52.0213 69.6739C52.1108 69.4881 52.1555 69.2438 52.1555 68.941V68.7653C52.1555 68.5658 52.1349 68.3938 52.0935 68.2491C52.059 68.0978 51.9903 67.9807 51.887 67.8982C51.7905 67.8088 51.6529 67.764 51.4739 67.764C51.2122 67.764 51.0331 67.857 50.9368 68.0428C50.8473 68.2285 50.8025 68.4695 50.8025 68.7653V68.941C50.8025 69.2438 50.8473 69.4881 50.9368 69.6739C51.0331 69.8528 51.2122 69.9423 51.4739 69.9423ZM56.4212 74.33C56.0561 74.33 55.7428 74.2681 55.4813 74.1442C55.2264 74.0203 55.0302 73.824 54.8925 73.5556C54.7617 73.2872 54.6963 72.9258 54.6963 72.4717C54.6963 72.0175 54.7617 71.6561 54.8925 71.3877C55.0302 71.1125 55.2264 70.9162 55.4813 70.7993C55.7428 70.6754 56.0561 70.6133 56.4212 70.6133C56.7931 70.6133 57.1064 70.6754 57.3611 70.7993C57.6226 70.9162 57.8189 71.1125 57.9497 71.3877C58.0807 71.6561 58.1461 72.0175 58.1461 72.4717C58.1461 72.9258 58.0807 73.2907 57.9497 73.5659C57.8189 73.8344 57.6226 74.0306 57.3611 74.1545C57.1064 74.2714 56.7931 74.33 56.4212 74.33ZM56.4212 73.5659C56.6897 73.5659 56.8687 73.4732 56.9583 73.2872C57.0478 73.1015 57.0925 72.8572 57.0925 72.5543V72.3787C57.0925 72.1791 57.0719 72.0072 57.0304 71.8627C56.996 71.7111 56.9306 71.5942 56.8343 71.5116C56.7448 71.4221 56.607 71.3774 56.4212 71.3774C56.1595 71.3774 55.9804 71.4703 55.8841 71.6561C55.7946 71.8418 55.7498 72.0828 55.7498 72.3787V72.5543C55.7498 72.8572 55.7946 73.1015 55.8841 73.2872C55.9804 73.4732 56.1595 73.5659 56.4212 73.5659Z",
    fill: "#E8E5FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7805 84.6626C68.6367 76.8098 68.6367 64.0779 60.7805 56.2251C52.9242 48.3723 40.1867 48.3723 32.3305 56.2251C24.4742 64.0779 24.4742 76.8098 32.3305 84.6626C40.1867 92.5154 52.9242 92.5154 60.7805 84.6626Z",
    stroke: "#496E9A",
    strokeWidth: 13.745
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5841 50.397C52.413 50.6478 57.1784 52.623 60.8767 56.3199C68.7803 64.2201 68.8187 76.9903 60.9625 84.8431C53.106 92.6959 40.3301 92.6577 32.4265 84.7576C28.0617 80.3945 26.0957 74.5463 26.5334 68.8612",
    stroke: "#82CEF0",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_1367_97434",
    x: 44.7627,
    y: 0,
    width: 247.7,
    height: 191.075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1367_97434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1367_97434",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 15.012,
    dy: 3.016
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.012
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3625 0 0 0 0 0.344375 0 0 0 0 0.344375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1367_97434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.142,
    dy: -7.278
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.555
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.118681 0 0 0 0 0.0447917 0 0 0 0 0.163542 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1367_97434",
    result: "effect3_innerShadow_1367_97434"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_1367_97434",
    x: 206.207,
    y: 92.1372,
    width: 105.337,
    height: 119.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1367_97434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1367_97434",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 18.544,
    dy: 3.726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.544
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.408333 0 0 0 0 0.401528 0 0 0 0 0.401528 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1367_97434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.756,
    dy: -2.712
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.751
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345319 0 0 0 0 0.318824 0 0 0 0 0.543922 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1367_97434",
    result: "effect3_innerShadow_1367_97434"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii_1367_97434",
    x: 0,
    y: 24.5488,
    width: 93.249,
    height: 101.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1367_97434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1367_97434",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14.966,
    dy: 3.007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425 0 0 0 0 0.389583 0 0 0 0 0.389583 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1367_97434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.61,
    dy: -2.189
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345319 0 0 0 0 0.318824 0 0 0 0 0.543922 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1367_97434",
    result: "effect3_innerShadow_1367_97434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1367_97434",
    x1: 96.0449,
    y1: 151.116,
    x2: 274.375,
    y2: 94.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#464647",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#171618",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCreateImageDark);
export default __webpack_public_path__ + "static/media/DashboardCreateImageDark.6e533095811c296aec20f093290bd327.svg";
export { ForwardRef as ReactComponent };